"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = void 0;
const shared_error_1 = require("@aladin/shared-error");
function isAxiosError(error) {
    var _a;
    return (_a = error.isAxiosError) !== null && _a !== void 0 ? _a : false;
}
/**
 * Helper method used to simplify axios error handling
 * @param error
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function handleError(error) {
    if (!isAxiosError(error)) {
        throw (0, shared_error_1.unknown)('Unhandled error', error);
    }
    if (!error.response) {
        throw (0, shared_error_1.unknown)('No Response');
    }
    const data = error.response.data;
    if ((0, shared_error_1.isAladinErrorData)(data)) {
        throw new shared_error_1.AladinError(data);
    }
    if (error.response.status === 401) {
        throw (0, shared_error_1.unauthorized)();
    }
    if (error.response.status === 403) {
        throw (0, shared_error_1.forbidden)();
    }
    throw (0, shared_error_1.unknown)('Unsupported error', error.response.data);
}
exports.handleError = handleError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2Vycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSx1REFBdUc7QUFHdkcsU0FBUyxZQUFZLENBQUMsS0FBYzs7SUFDbEMsT0FBTyxNQUFDLEtBQTZCLENBQUMsWUFBWSxtQ0FBSSxLQUFLLENBQUE7QUFDN0QsQ0FBQztBQUVEOzs7R0FHRztBQUNILGlIQUFpSDtBQUNqSCxTQUFnQixXQUFXLENBQUMsS0FBVTtJQUNwQyxJQUFHLENBQUMsWUFBWSxDQUFDLEtBQUssQ0FBQyxFQUFFO1FBQ3ZCLE1BQU0sSUFBQSxzQkFBTyxFQUFDLGlCQUFpQixFQUFFLEtBQUssQ0FBQyxDQUFBO0tBQ3hDO0lBQ0QsSUFBRyxDQUFDLEtBQUssQ0FBQyxRQUFRLEVBQUU7UUFDbEIsTUFBTSxJQUFBLHNCQUFPLEVBQUMsYUFBYSxDQUFDLENBQUE7S0FDN0I7SUFDRCxNQUFNLElBQUksR0FBRyxLQUFLLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQTtJQUNoQyxJQUFHLElBQUEsZ0NBQWlCLEVBQUMsSUFBSSxDQUFDLEVBQUM7UUFDekIsTUFBTSxJQUFJLDBCQUFXLENBQUMsSUFBSSxDQUFDLENBQUE7S0FDNUI7SUFDRCxJQUFJLEtBQUssQ0FBQyxRQUFRLENBQUMsTUFBTSxLQUFLLEdBQUcsRUFBRTtRQUNqQyxNQUFNLElBQUEsMkJBQVksR0FBRSxDQUFBO0tBQ3JCO0lBQ0QsSUFBSSxLQUFLLENBQUMsUUFBUSxDQUFDLE1BQU0sS0FBSyxHQUFHLEVBQUU7UUFDakMsTUFBTSxJQUFBLHdCQUFTLEdBQUUsQ0FBQTtLQUNsQjtJQUNELE1BQU0sSUFBQSxzQkFBTyxFQUFDLG1CQUFtQixFQUFFLEtBQUssQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUE7QUFDekQsQ0FBQztBQWxCRCxrQ0FrQkMifQ==